import { PlayerConfig } from '@foundation-player/core';
import { Environment, Platform } from '@foundation-player/runtime';
import { ClientAndScope } from '@foundation-player/types';
import { BuilderConfig } from '../../builder-config';
import { addBitmovinLicenseKey } from './add-bitmovin-license-key';
import { addBolaAbr } from './add-bola-abr';
import { addPreferredKeySystems } from './add-preferred-key-systems';
import { addStusConfig } from './add-stus-config';

/**
 * Use this type for your transform functions
 */
export type TransformPlayerConfig = (
  partialBuilderConfig: Omit<BuilderConfig, 'playerConfig' | 'pluginConfigs'>,
  playerConfig: PlayerConfig,
  clientAndScope?: ClientAndScope,
  environment?: Environment,
  platform?: Platform,
) => PlayerConfig;

/**
 * This function is used to transform the player config before it is passed to the builder.
 *
 * @remarks
 * The purpose is to define all transformers here and call them in order.
 */
export const transformPlayerConfig: TransformPlayerConfig = (
  partialBuilderConfig,
  playerConfig,
  clientAndScope,
  environment,
  platform,
) => {
  let transformedPlayerConfig = playerConfig;

  const transformers: TransformPlayerConfig[] = [
    addBitmovinLicenseKey,
    addStusConfig,
    addPreferredKeySystems,
    addBolaAbr,
  ];

  for (const transformer of transformers) {
    transformedPlayerConfig = transformer(
      partialBuilderConfig,
      transformedPlayerConfig,
      clientAndScope,
      environment,
      platform,
    );
  }

  return transformedPlayerConfig;
};
